export default __webpack_public_path__ + "static/media/partners-salus.bd2e41fc.png";